<template>
    <div class="team">
      <div class="title">
        <van-tabs v-model="active" line-width="16px">
          <van-tab title="队伍">
            <div class="team-box">
              <MyField label="队伍名称">
                <input type="text" v-model="teamObj.name" placeholder="请输入队伍名称">
              </MyField>
              <MyField label="联系人" v-if="teamCheckboxes.contactPerson">
                <input type="text" v-model="teamObj.contactPerson" placeholder="请输入联系人姓名">
              </MyField>
              <MyField label="联系方式" v-if="teamCheckboxes.contactNumber">
                <input type="number" v-model="teamObj.contactNumber" placeholder="请输入联系电话">
              </MyField>
              <div v-if="teamCheckboxes.badge" class="needIcon">
                队徽
                <div style="margin-top: 6px;">
                  <van-uploader v-model="accessory" max-count="1" :after-read="uploadAvatar" @delete="deleteAvatar"/>
                </div>
              </div>
              <MyField label="队伍介绍" v-if="teamCheckboxes.summary">
                <input type="text" v-model="teamObj.summary" placeholder="请输入队伍介绍">
              </MyField>
              <MyField label="主队服颜色" v-if="teamCheckboxes.homeColor" class="team-color">
                <van-dropdown-menu active-color="#1989fa">
                  <van-dropdown-item :title="teamObj.homeColor" ref="homeColor">
                    <div v-for="item in imgList" :key="item.value" class="color" @click="onConfirm(item,'homeColor')">
                      <img :src="item.url" style="width: 20px;height: 20px;">
                    </div>
                  </van-dropdown-item>
                </van-dropdown-menu>
              </MyField>
              <MyField label="客队服颜色" v-if="teamCheckboxes.awayColor" class="team-color">
                <van-dropdown-menu active-color="#1989fa">
                  <van-dropdown-item :title="teamObj.awayColor" ref="awayColor">
                    <div v-for="item in imgList" :key="item.value" class="color" @click="onConfirm(item,'awayColor')">
                      <img :src="item.url" style="width: 20px;height: 20px;">
                    </div>
                  </van-dropdown-item>
                </van-dropdown-menu>
              </MyField>
              <van-field
                v-if="teamCheckboxes.clothesId"
                v-model="teamObj.clothesId"
                placeholder="请选择球衣款式"
                readonly clickable
                @click="previewImg(teamObj.clothesId)"
                input-align="right"
                label-align="left"
                class="my-field"
              >
                <template #label>
                  <div style="font-size: 14px; color: #000000">球衣款式</div>
                </template>
                <template #input>
                  <div v-if="teamObj.clothesId">
                    <van-image :src="imageView(getClothesImg(teamObj.clothesId))" style="width: 24px; height: 24px;" alt=""></van-image>
                  </div>
                </template>
              </van-field>
              <div class="clotheses" v-if="teamCheckboxes.clothesId">
                <div class="clothes" :class="teamObj.clothesId == item.id ? 'selected' : ''" v-for="(item, index) in clothes" :key="'clothes' + index" @click="chooseClothes(item)">
                  <img class="img" :src="imageView(item.image)" alt="">
                </div>
              </div>
              <div style="height: 82px;"></div>
              <div class="footer">
                <div @click="createTeam">保存</div>
              </div>
            </div>
          </van-tab>
          <van-tab title="队员">
            <div class="list" v-if="players.length > 0">
                <div class="item flex-center" v-for="item in players" :key="item.id">
                    <van-image class="img" :src="imageView(item.avatar, 100, 100)" />
                    <div class="info">
                        <p><span>{{ item.number }}</span> {{ item.trueName }}</p>
                    </div>
                    <div class="update" @click="goTeam(item.id)">
                        <van-icon name="edit" size="20px" color="#000" style="margin-bottom: 6px;" />
                        编辑
                    </div>
                </div>
                <div class="add" @click="goTeam()">
                    <van-icon name="add-o"  size="18px" style="margin-bottom: 6px;font-weight: 900;"/>
                    快速添加
                </div>
            </div>
            <div v-else class="list">
              <van-empty description="暂无队员" />
              <div class="add" @click="goTeam()">
                  <van-icon name="add-o"  size="18px" style="margin-bottom: 6px;font-weight: 900;"/>
                  快速添加
              </div>
            </div>
          </van-tab>
        </van-tabs>
      </div>
    </div>
</template>

<script>
import { Image as VanImage, Tabs, Tab, Toast, Uploader, DropdownMenu, DropdownItem, Empty, ImagePreview, Field } from "vant";
import Vue from 'vue'
Vue.use(Tabs).use(Tab).use(Toast).use(Uploader).use(DropdownMenu).use(DropdownItem).use(VanImage).use(Empty).use(ImagePreview).use(Field)
import MyField from '../components/Field.vue'
import {
  adminGetBMMatch,
  adminGetBMMatchTeam,
  adminUpdateBMMatchTeam,
  adminCreateBMTeam,
  getBMMatchTeamSignup
} from "@/api/match";
import { getQiniuUploadToken, uploadImage } from '@/api/qiniu'
import { QNImageUtil } from '@/utils'
export default {
  components: {
    MyField
  },
  data() {
    return {
      active: 0,
      match: {},
      accessory: [],
      qiniuToken: '',
      imgList: [
        { value: '1', label: '白色', url: 'http://images.snsports.cn/qy_1.png'},
        { value: '2', label: '蓝色', url: 'http://images.snsports.cn/qy_2.png'},
        { value: '3', label: '暗红', url: 'http://images.snsports.cn/qy_3.png'},
        { value: '4', label: '深黄', url: 'http://images.snsports.cn/qy_4.png'},
        { value: '5', label: '绿色', url: 'http://images.snsports.cn/qy_5.png'},
        { value: '6', label: '紫色', url: 'http://images.snsports.cn/qy_6.png'},
        { value: '7', label: '橙色', url: 'http://images.snsports.cn/qy_7.png'},
        { value: '8', label: '黑色', url: 'http://images.snsports.cn/qy_8.png'},
        { value: '9', label: '白底黑条纹', url: 'http://images.snsports.cn/qy_9.png'},
        { value: '10', label: '紫底黑条纹', url: 'http://images.snsports.cn/qy_10.png'},
        { value: '11', label: '白底红条纹', url: 'http://images.snsports.cn/qy_11.png'},
        { value: '12', label: '红底黑条纹', url: 'http://images.snsports.cn/qy_12.png'},
        { value: '13', label: '黄底红条纹', url: 'http://images.snsports.cn/qy_13.png'},
        { value: '14', label: '红底紫条纹', url: 'http://images.snsports.cn/qy_14.png'},
        { value: '15', label: '白底蓝条纹', url: 'http://images.snsports.cn/qy_15.png'},
        { value: '16', label: '黄底绿条纹', url: 'http://images.snsports.cn/qy_16.png'},
        { value: '17', label: '白底黑条纹（竖）', url: 'http://images.snsports.cn/qy_17.png'},
        { value: '18', label: '白底红条纹（竖）', url: 'http://images.snsports.cn/qy_18.png'},
        { value: '19', label: '白底黄条纹（竖）', url: 'http://images.snsports.cn/qy_19.png'},
        { value: '20', label: '白底蓝条纹（竖）', url: 'http://images.snsports.cn/qy_20.png'},
        { value: '21', label: '红底黑条纹（竖）', url: 'http://images.snsports.cn/qy_21.png'},
        { value: '22', label: '红底紫条纹（竖）', url: 'http://images.snsports.cn/qy_22.png'},
        { value: '23', label: '黄底黑条纹（竖）', url: 'http://images.snsports.cn/qy_23.png'},
        { value: '24', label: '黄底绿条纹（竖）', url: 'http://images.snsports.cn/qy_24.png'},
        { value: '25', label: '粉红', url: 'http://images.snsports.cn/qy_25.png'},
        { value: '26', label: '天蓝', url: 'http://images.snsports.cn/qy_26.png'},
        { value: '27', label: '浅黄', url: 'http://images.snsports.cn/qy_27.png'}
      ],
      clothes: [],
      teamObj: {
        name: '',
        contactPerson: '',
        contactNumber: '',
        badge: '',
        summary: '',
        homeClothesColor: '',
        awayClothesColor: '',
        homeColor: '', // 主队服颜色名
        awayColor: '', // 客队服颜色名
        clothesId: ''
      },
      id: '',
      matchId: '',
      players: [],
      teamCheckboxes: {}
    };
  },
  mounted() {
    this.matchId = this.$route.query.matchId
    this.id = this.$route.query.id
    this.adminGetBMMatch()
    this.getQiniuUploadToken()
    if (this.id) {
      this.adminGetBMMatchTeam()
    }
  },
  methods: {
    chooseClothes(item) {
      this.$set(this.teamObj, 'clothesId', item.id)
    },
    previewImg(img){
      if (!img) return
      ImagePreview([
        this.imageView((this.getClothesImg(img)))
      ])
    },
    getQiniuUploadToken() {
      getQiniuUploadToken({}).then(res => {
        this.qiniuToken = res.data.token
      })
    },
    adminGetBMMatch() {
      adminGetBMMatch({ id: this.matchId }).then(res => {
        this.match = res.data.match
        const tsfs = this.match.teamSignupFields && this.match.teamSignupFields.split('|') || []
        const teamCheckboxes = {}
        tsfs.forEach(psf => {
          teamCheckboxes[psf] = true
        })
        this.teamCheckboxes = teamCheckboxes
        this.getBMMatchTeamSignup()
      })
    },
    getBMMatchTeamSignup() {
      const params = {
        matchId: this.matchId,
      }
      if (this.teamId) {
        params.teamId = this.id
      }
      getBMMatchTeamSignup(params).then(res => {
        if (res) {
          const data = res.data || {}
          this.clothes = data.clothes || []
        }
      })
    },
    adminGetBMMatchTeam() {
      adminGetBMMatchTeam({ id: this.id, matchId: this.matchId }).then(res => {
        const team = res.data.team
        if (team.homeClothesColor) {
          const home = this.imgList.find(item => item.value == team.homeClothesColor)
          team.homeColor = home.label
        }
        if (team.awayClothesColor) {
          const away = this.imgList.find(item => item.value == team.awayClothesColor)
          team.awayColor = away.label
        }
        if (team.badge) {
          this.accessory.push({ url: this.imageView(team.badge, 120, 120), isImage: true })
        }
        this.teamObj = team
        this.players = team.players || []
      })
    },
    uploadAvatar(file) {
      const formData = new FormData()
      formData.append('token', this.qiniuToken)
      formData.append('file', file.file)
      uploadImage(formData).then(res => {
        this.$set(this.teamObj, 'badge', res.hash)
      })
    },
    deleteAvatar() {
      this.$set(this.teamObj, 'badge', '')
    },
    onConfirm(obj,type) {
      const teamObj = JSON.parse(JSON.stringify(this.teamObj))
      teamObj[type] = obj.label
      if (type === 'homeColor') {
        teamObj.homeClothesColor = obj.value
      }
      if (type === 'awayColor') {
        teamObj.awayClothesColor = obj.value
      }
      this.teamObj = teamObj
      const dropdown = this.$refs[type]
      dropdown.toggle();
    },
    imageView(img, w, h) {
      if (!img) return 'https://images.snsports.cn/FrB9e_-z4Gj4879NuraIWmiVDkv_'
      return QNImageUtil.imageView(img, w, h)
    },
    getClothesImg(id) {
      const c = this.clothes.find(item => item.id === id)
      if (!c) return ''
      return c.image
    },
    createTeam() {
      if(!this.teamObj.name) return Toast('请输入队伍名称～')
      if(this.teamCheckboxes.contactPerson && !this.teamObj.contactPerson) return Toast('请输入领队姓名～')
      if(this.teamCheckboxes.contactNumber && !this.teamObj.contactNumber) return Toast('请输入联系方式～')
      if (this.id) {
        const params = {
          ...this.teamObj,
          id: this.id,
          matchId: this.matchId
        }
        adminUpdateBMMatchTeam(params).then(res => {
          console.log(res);
          Toast('编辑成功～')
          this.$router.back()
        })
      } else {
        const params = {
          ...this.teamObj,
          matchId: this.matchId
        }
        adminCreateBMTeam(params).then(res => {
          console.log(res);
          Toast('添加成功～')
          this.$router.back()
        })
      }
    },
    goTeam(id) {
      const query = { matchId: this.matchId,teamId: this.id }
      if (id) query.id = id
      this.$router.push({ path: `/match-manage/apply-player`, query })
    }
  }
};
</script>

<style scoped lang="scss">
::v-deep .van-cell {
  padding: 12px 0;
}
.team{
  border-top: 12px solid #F6F6F8;
  background-color: #F6F6F8;
  min-height: 100vh;
  .title{
    background-color: #fff;
    ::v-deep .van-tabs__content{
      border-top: 1px solid #F6F6F8;
    }
    ::v-deep .van-tabs__wrap{
      width: 180px !important;
    }
    .team-box{
      padding:2px 16px;
      .clotheses {
        padding: 12px 16px;
        overflow-x: auto;
        white-space: nowrap;
        .clothes {
          position: relative;
          display: inline-block;
          width: 60px;
          height: 60px;
          margin-right: 8px;
          border-radius: 4px;
          background-color: #DFDFDF;
          box-sizing: border-box;
          .img {
            width: 60px;
            height: 60px;
          }
          .disabled {
            position: absolute;
            top: 0;
            width: 60px;
            height: 60px;
            border-radius: 4px;
            background-color: #000000;
            opacity: 0.3;
            display: flex;
            align-items: center;
            justify-content: center;
            .lock {
              width: 16px;
              height: 16px;
            }
          }
        }
        .selected {
          box-sizing: border-box;
          box-shadow: 2px 2px 2px 1px rgba(0, 0, 0, .3);
        }
      }
      input{
        border: none;
        text-align: right;
      }
      .needIcon{
        font-size: 14px;
        border-bottom: 1px solid #F3F3F3;
        padding: 10px 0px;
        line-height: 30px;
        box-sizing: border-box;
      }
      ::v-deep .van-dropdown-menu__bar{
        box-shadow: none !important;
      }
      ::v-deep .van-dropdown-menu__title::after{
        right: 0px;
      }
      ::v-deep .van-ellipsis{
        padding-right: 5px;
      }
      .team-color{
        ::v-deep .slot{
          flex: 1;
        }
        ::v-deep .van-dropdown-menu__item{
          justify-content: end;
        }
      }
      .color{
        text-align: center;
        padding: 5px 0;
        border-bottom: 1px solid #F3F3F3;
      }
      .footer{
        position: fixed;
        bottom: 0;
        left: 0;
        background-color: #fff;
        width: 100%;
        padding: 16px 12px;
        div{
          height: 50px;
          background: #1565FC;
          border-radius: 25px;
          color: #fff;
          font-size: 16px;
          text-align: center;
          line-height: 50px;
          width: 351px;
        }
      }
    }
  }
  .list{
        padding: 12px 16px;
        .item{
            padding: 12px;
            background-color: #F9FAFC;
            border-radius: 8px;
            margin-bottom: 12px;
            .img{
                border-radius: 2px;
                width: 48px;
                height: 48px;
                overflow: hidden;
                border: 1px solid #E5E5E5;
                margin-right: 8px;
            }
            .info{
                flex: 1;
                font-size: 14px;
                p{
                    margin: 0;
                    font-weight: 500;
                    color: #191919;
                }
                div{
                    color: #8C8C8C;
                    margin-top: 11px;
                }
            }
            .update{
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: space-evenly;
                color: #8C8C8C;
                font-size: 14px;
            }
            .name{
                color: #282828;
                font-size: 14px;
                border-bottom: 1px solid #EEEEEE;
                padding-top: 4px;
                padding-bottom: 11px;
            }
        }
    }
    .add{
        height: 72px;
        background: #F5F8FF;
        border-radius: 8px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: #1565FC;
        font-size: 14px;
    }
}
</style>
